import { Box, Menu, MenuItem } from "@mui/material";
import React from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const displayMapping = {
  "Last Week": "Last 7 Days",
  "Last Month": "Last 30 Days",
  "Last 3 Months": "Last 3 Months",
  "Any Time": "Any Time",
};

export const FilterTypes = ({
  selectedTime,
  handleClick,
  handleClose,
  anchorEl,
  open,
}) => {
  return (
    <>
      <Box
        id="jobs-menu-button"
        aria-controls={open ? "jobs-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          background: "#FFF",
          px: 1.25,
          py: 0.75,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          cursor: "pointer",
          color: "#000",
          borderRadius: 1.5,
          width: "fit-content",
        }}
      >
        <span style={{ width: "100%", fontSize: "14px" }}>
          {selectedTime
            ? displayMapping[selectedTime] || selectedTime
            : "Last 7 Days"}
        </span>
        <KeyboardArrowDownOutlinedIcon sx={{ fontSize: "16px" }} />
      </Box>
      <Menu
        id="jobs-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(null)}
        MenuListProps={{ "aria-labelledby": "jobs-menu-button" }}
        sx={{ "& ul": { padding: "4px 0" } }}
      >
        {["Last Week", "Last Month", "Last 3 Months", "Any Time"].map(
          (filterItem) => (
            <MenuItem
              key={filterItem}
              selected={selectedTime === filterItem}
              onClick={() => handleClose(filterItem)}
              sx={{
                mx: 0.5,
                mb: filterItem === "Any Time" ? "" : 0.5,
                px: 1.5,
                borderRadius: 1,
                fontSize: "12px",
                color: "#000 !important",
                // ── selected: light blue ──
                background:
                  selectedTime === filterItem
                    ? "#d7e8f7 !important"
                    : "transparent !important",
                // ── hover: grey ──
                "&:hover": { background: "#E0E0E0 !important" },
                "&.Mui-focusVisible": { background: "#E0E0E0 !important" },
              }}
            >
              {filterItem}
            </MenuItem>
          ),
        )}
      </Menu>
    </>
  );
};
